import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getDefaultHomePath } from "../lib/screenAccess";

const SmartRedirect: React.FC = () => {
  const { token, user } = useAuth();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getDefaultHomePath(user)} replace />;
};

export default SmartRedirect;
